module.exports = __webpack_public_path__ + "img/gift3-01-c10.d031e781.png";